uniform samplerCube envMap;
uniform float opacity;
varying vec3 vWorldDir;
void main() {
    vec4 c = textureCube(envMap, normalize(vWorldDir));
    gl_FragColor = vec4(c.rgb, c.a * opacity);
}